
const gmapElements = document.querySelectorAll('[data-gmap]');

const allowGmaps = false; // TODO: Get value from cookie banner

const renderGmaps = async () => {
  gmapElements.forEach(gmap => {
    const acceptanceEl = gmap.querySelector('.gmaps-acceptance');
    const iframe = document.createElement('iframe');
    iframe.src = gmap.dataset.gmapSrc;
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('width', gmap.dataset.gmapWidth || 600);
    iframe.setAttribute('height', gmap.dataset.gmapHeight || 450);
    iframe.setAttribute('style', 'border:0;');
    gmap.appendChild(iframe);
    acceptanceEl && acceptanceEl.remove();
  });
};

const displayGmapsAcceptanceBtn = () => {
  gmapElements.forEach(gmap => {
    const acceptanceEl = document.createElement('div');
    const acceptanceBtn = document.createElement('button');
    acceptanceEl.classList.add('gmaps-acceptance');
    acceptanceEl.innerHTML =
      'Wir nutzen für unsere Karte den Dienst von Google Maps. Eine Einbindung und Datenweitergabe an Google erfolgt erst, nachdem Sie dem zugestimmt haben. Weitere Informationen finden Sie in den Informationen zum <a href="https://www.museumpab.de/datenschutz/">Datenschutz</a>.';
    acceptanceBtn.textContent = 'Google maps erlauben und ansehen';
    acceptanceBtn.classList.add('btn-primary');
    acceptanceEl.appendChild(acceptanceBtn);
    gmap.appendChild(acceptanceEl);

    acceptanceBtn.onclick = async () => {
      // TODO: change cookie to allow google maps
      await renderGmaps();
      acceptanceEl.remove();
    };
  });
};

if (gmapElements) {
  if (!allowGmaps) {
    displayGmapsAcceptanceBtn();
  } else {
    renderGmaps();
  }
}
